import { Component, OnInit, Input } from '@angular/core';
import { WidgetService } from '../widget.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { ModuleType } from '@fi-shared/types';
import { WidgetContentModel } from '@fi-app/widget/model/widget-content.model';

@Component({
    selector: 'fi-widget-list',
    templateUrl: './widget-list.component.html',
    styleUrls: ['./widget-list.component.scss'],
    standalone: false,
})
export class WidgetListComponent implements OnInit {
    @Input('moduleType') ngModel: ModuleType;
    @Input() objectId: number;
    @Input() objectType: ObjectTypes;

    moduleWidgets: WidgetContentModel[];
    WidgetsMap: { [prop: number]: WidgetModel };

    constructor(
        private widgetService: WidgetService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        const siteDesignId = this.userDataService.getActiveSiteDesignId();

        this.widgetService
            .getWidgets(ObjectTypes.SideBar, {
                loadContents: false,
            })
            .then((widgets) => {
                this.WidgetsMap = {};
                widgets.forEach((widget) => {
                    this.WidgetsMap[widget.WidgetType] = widget;
                });

                const promise = this.widgetService.GetWidgetModuleContents(
                    this.ngModel,
                    this.objectId,
                    this.objectType,
                    siteDesignId,
                );
                promise.then((data) => {
                    if (data) {
                        this.moduleWidgets = data;

                        this.moduleWidgets.sort((firstItem, secondItem) => {
                            return firstItem.SortOrder - secondItem.SortOrder;
                        });
                    }
                });
            });
    }
}
